import React from "react";

interface StepProps {
  stepNum: number;
  currentStep: number;
  title: string;
}

const Step: React.FC<StepProps> = ({
  stepNum,
  currentStep,
  title,
  children,
}) => {
  const completed = stepNum < currentStep;
  return (
    <div
      id={`step-${stepNum}`}
      className={`flex flex-col justify-start items-start gap-4`}
    >
      <div className="flex flex-row justify-center items-start gap-4">
        <div
          className={`w-8 h-8 flex justify-center items-center rounded-full ${
            completed || currentStep === stepNum
              ? "bg-acala-blue-500 text-white"
              : "bg-transparent border border-acala-blue-400 text-acala-blue-400"
          }`}
        >
          {stepNum < currentStep ? (
            <img className="w-4" src="/Check White.svg" alt="Step completed check mark" />
          ) : (
            stepNum
          )}
        </div>
        <h1
          className={`text-lg font-semibold ${
            currentStep !== stepNum ? "opacity-50" : ""
          } text-gray-900`}
        >
          {title}
        </h1>
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex flex-col items-center w-8">
          <div
            className={`flex flex-col h-full w-[1px] ${
              currentStep > stepNum ? "bg-acala-blue-500" : "bg-acala-blue-300"
            }`}
          ></div>
        </div>
        <div className={`${currentStep !== stepNum ? " opacity-50" : ""}`}>{children}</div>
      </div>
    </div>
  );
};

export default Step;
